import { useRef } from 'react'

const SESSION_KEY = 'inscalar_previous_step'

export function useInscalarPreviousStep() {
    const hasTrackedInitialRef = useRef(false)

    const advance = (currentStep: string | undefined): string | undefined => {
        if (typeof window === 'undefined') return undefined

        const previousStep = sessionStorage.getItem(SESSION_KEY) ?? undefined

        if (currentStep != null) {
            sessionStorage.setItem(SESSION_KEY, currentStep)
        } else {
            sessionStorage.removeItem(SESSION_KEY)
        }

        hasTrackedInitialRef.current = true
        return previousStep
    }

    return { advance, isFirstVisit: !hasTrackedInitialRef.current }
}
